export type SeoErrorCode = 'BREADCRUMB_WITHOUT_CRUMBS' | 'FAQ_PAGE_WITHOUT_QUESTIONS' | 'ROUTE_TITLE_IS_BARE_BRAND' | 'TECH_ARTICLE_WITHOUT_HEADLINE' | 'UNKNOWN_HUB_SLUG' | 'UNSUPPORTED_METADATA_FIELD' | 'UNSUPPORTED_SITEMAP_FIELD';

export class SeoError extends Error {
  readonly code: SeoErrorCode;

  constructor(code: SeoErrorCode, message: string) {
    super(message);
    this.code = code;
    this.name = 'SeoError';
  }
}
